import { render, staticRenderFns } from "./PtTermsOfUse.vue?vue&type=template&id=5392893e&scoped=true"
import script from "./PtTermsOfUse.vue?vue&type=script&lang=js"
export * from "./PtTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5392893e",
  null
  ,true
)

export default component.exports